import { cn } from '../../lib/utils.ts';
import SmallSpinner from '../ui/small-spinner.tsx';
import { LoadingSpinner } from './loading-spinner.tsx';

type Props = {
    className?: string;
    smallSpinner?: boolean;
};
export function LoadingBlock({ className, smallSpinner = true }: Props) {
    return (
        <div className={cn('flex w-full flex-col items-center justify-center py-20', className)}>
            {smallSpinner ? <SmallSpinner /> : <LoadingSpinner />}
        </div>
    );
}
